import React from "react";
import { DatePicker as AntdDatePicker } from "antd";
import type { DatePickerProps as AntdDatePickerProps } from "antd";

const { RangePicker: AntdRangePicker } = AntdDatePicker;

export type DatePickerProps = AntdDatePickerProps;
export type RangePickerProps = React.ComponentProps<typeof AntdRangePicker>;

/**
 * DatePicker component - date selection field
 */
const DatePicker: React.FC<DatePickerProps> & {
  RangePicker: typeof AntdRangePicker;
} = (props) => {
  return <AntdDatePicker {...props} />;
};

// Attach static properties
DatePicker.RangePicker = AntdRangePicker;

export default DatePicker;
